// Страницы, которые не будут перекрываться незакрываемой модалкой AgeConfirmationModalComponent
export const EXCLUDED_PATHS = [
  '/privacy-policy',
  '/terms-and-conditions',
  '/refund-policy',
  '/blocked-content-policy',
  '/community-guidelines',
  '/content-removal-policy',
  '/underage-policy',
];
